import { UTIL_AUTH_IGNORE, UTIL_AUTH_IGNORE_REMOVE, UTIL_ROUTE as UTIL_ROUTE, UTIL_DEVSIMULATE_STATE, UTIL_HEADER_IGNORE, UTIL_REDUXVIEW_STATE, UTIL_SIDEBAR_IGNORE, UTIL_SIDEBARLIST_STATE, UTIL_SISTEMAID, UTIL_START_STATE, UTIL_USERDATA_STATE, ConditionalRoute, UTIL_ROUTE_STATE } from 'domain/types/util/util';
import { AppThunk } from '../../../utils/reducerUtil';
import SideBarOptions from '../../../utils/SideBarOptions';
import { UsuarioResponse } from 'domain/types/usuario/usuarioResponse';
import { ReduxViewProps } from '../../../view/states/reduxView';

export function SetSistemaID(sistemaID: number | undefined): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: sistemaID,
            type: UTIL_SISTEMAID
        });
    };
}


export function IgnoreSideBar(location?: string): AppThunk {
    return async (dispatch) => {
        if (location == null) { return }
        dispatch({
            payload: location,
            type: UTIL_SIDEBAR_IGNORE
        });
    };
}

export function IgnoreHeader(location?: string): AppThunk {
    return async (dispatch) => {
        if (location == null) { return }
        dispatch({
            payload: location,
            type: UTIL_HEADER_IGNORE
        });
    };
}

export function IgnoreAuth(location?: string): AppThunk {
    return async (dispatch) => {
        if (location == null) { return }
        dispatch({
            payload: location,
            type: UTIL_AUTH_IGNORE
        });
    };
}

export function IgnoreAuthRemove(location?: string): AppThunk {
    return async (dispatch) => {
        if (location == null) { return }
        dispatch({
            payload: location,
            type: UTIL_AUTH_IGNORE_REMOVE
        });
    };
}

export function StartState(state: boolean): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: state,
            type: UTIL_START_STATE
        });
    };
}

export function SetSideBar(sideBarList: SideBarOptions[]): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: sideBarList,
            type: UTIL_SIDEBARLIST_STATE
        });
    };
}

export function SetUserData(usuario: UsuarioResponse): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: usuario,
            type: UTIL_USERDATA_STATE
        });
    };
}

export function SetReduxView(value : ReduxViewProps): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: value,
            type: UTIL_REDUXVIEW_STATE
        });
    };
}

export function SetSimulate(value : boolean): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: value,
            type: UTIL_DEVSIMULATE_STATE
        });
    };
}

export function AddRoute(route: ConditionalRoute): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: route,
            type: UTIL_ROUTE
        });
    };
}

export function StatusRoute (path: string, status : boolean): AppThunk {
    return async (dispatch) => {
        dispatch({
             type: UTIL_ROUTE_STATE,
             payload: { Path: path, Status: status } as ConditionalRoute
        });
    };
}